import { createRouter, createWebHashHistory } from 'vue-router';
import store from './core/store';
import { checkAuthenticated } from './core/utils';
import { abortController, reinitController } from './core/AbortController';

const routes = [
  {
    path: '/',
    name: 'kron',
    meta: { layout: 'main', title: '', requiresAuth: true },
    children: [
      { path: '/facility-form/:node_type_id/:facility_id/:facility_type_id', name: 'form', component: () => import('./pages/scada/FacilityForm.vue') },
    ],
    component: () => import('./pages/scada/structure/Structure.vue'),
  },
  {
    path: '/login',
    name: 'login',
    meta: { title: 'Авторизация', layout: 'empty' },
    component: () => import('./core/main/Login.vue'),
  },
  {
    path: '/change-password',
    name: 'change-password',
    meta: { title: 'Пароль КРОН-ТМ устарел', layout: 'empty' },
    component: () => import('./core/main/ChangePassword.vue'),
  },
  {
    path: '/report-viewer/:id',
    name: 'report-viewer',
    meta: { layout: 'main', title: 'Отчёт', requiresAuth: true },
    component: () => import('./core/report/ReportViewer.vue'),
  },
  {
    path: '/report-designer/:id',
    name: 'report-designer',
    meta: { layout: 'main', title: 'Дизайнер', requiresAuth: true },
    component: () => import('./core/report/ReportDesigner.vue'),
  },
  {
    path: '/report',
    name: 'report',
    meta: { layout: 'main', title: 'Отчёты', requiresAuth: true },
    component: () => import('./pages/report/ReportsData.vue'),
  },
  {
    path: '/facility',
    name: 'facility',
    meta: { layout: 'main', title: 'Все объекты', requiresAuth: true },
    component: () => import('./pages/facility/FacilityData.vue'),
  },
  {
    path: '/facility-map',
    name: 'facility-map',
    meta: { layout: 'main', title: 'Карта объектов', requiresAuth: true },
    children: [
      { path: '/facility-map/:node_type_id/:facility_id/:facility_type_id', name: 'facility-map-child', component: () => import('./pages/scada/map/FacilityMapChild.vue') },
    ],
    component: () => import('./pages/scada/map/FacilityMap.vue'),
  },
  {
    path: '/property-type',
    name: 'property-type',
    meta: { layout: 'main', title: 'Редактор типов свойств', requiresAuth: true },
    component: () => import('./pages/property/PropertyTypeData.vue'),
  },
  {
    path: '/users',
    name: 'users',
    meta: { layout: 'main', title: 'Пользователи и роли', requiresAuth: true },
    component: () => import('./pages/users/UserData.vue'),
  },
  {
    path: '/setting',
    name: 'setting',
    meta: { layout: 'main', title: 'Настройки', requiresAuth: true },
    component: () => import('./pages/common/Setting.vue'),
  },
  {
    path: '/feedback',
    name: 'feedback',
    meta: { layout: 'main', title: 'Обратная связь', requiresAuth: true },
    component: () => import('./pages/common/Feedback.vue'),
  },
  {
    path: '/request-user',
    name: 'request-user',
    meta: { layout: 'main', title: 'Заявки', requiresAuth: true },
    component: () => import('./pages/request/RequestUser.vue'),
  },
  {
    path: '/source',
    name: 'source',
    meta: { layout: 'main', title: 'Источники', requiresAuth: true },
    component: () => import('./pages/source/SourceData.vue'),
  },
  {
    path: '/news',
    name: 'news',
    meta: { layout: 'main', title: 'Уведомления и новости', requiresAuth: true },
    component: () => import('./pages/news/NewsData.vue'),
  },
  {
    path: '/news-history',
    name: 'news-history',
    meta: { layout: 'main', title: 'Уведомления и новости', requiresAuth: true },
    component: () => import('./pages/newsHistory/NewsHistoryData.vue'),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

/**
 * Router navigation guard for authentication and authorization.
 */
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  
  // Set page title
  const programName = store.getters.const('PROGARM_NAME_RU');
  const serverName = store.getters.constStrict(process.env.VUE_APP_SERVER_NAME) ?? 
                     store.getters.const(process.env.VUE_APP_SERVER_NAME);
  document.title = `${programName} ${serverName ?? ''} ${to.meta?.title ?? ''}`.trim();

  // Check if route requires authentication
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Check if user is authenticated
    if (!checkAuthenticated()) {
      const query = to.fullPath.match(/^\/$/) ? {} : { redirect: to.fullPath };
      next({ path: '/login', query });
      return;
    }
    
    // Check if password needs to be changed
    if (store.getters.info.passwordIsOld) {
      const query = to.fullPath.match(/^\/$/) ? {} : { redirect: to.fullPath, type: 'system' };
      next({ path: '/change-password', query });
      return;
    }
    
    // Update title with route params
    if (to.params.id) {
      document.title = `${to.meta.title} №${to.params.id}`;
    }
    
    // Reset and reinitialize abort controller
    abortController();
    reinitController();
  }

  next();
});

export default router;